import CTAButtons from '../CTAButtons/CTAButtons';
import MockThumb from '../MockThumb/MockThumb';
import { mockAssets } from '../../config/mockAssets';
import { stockAssets } from '../../config/stockAssets';
import styles from './Hero.module.css';

function Hero() {
  return (
    <section className={styles.hero} aria-labelledby="hero-heading">
      <div className={`container ${styles.grid}`}>
        <div className={styles.copy}>
          <p className={styles.eyebrow}>Built for stadium and arena operators</p>
          <h1 id="hero-heading" className={styles.title}>
            Transform Stadium Concessions into Premium Guest Experiences
          </h1>
          <p className={styles.subtitle}>
            ONI increases concession revenue, reduces lines, and delivers food directly to every seat —
            all through one secure platform.
          </p>
          <CTAButtons size="lg" showAdmin={false} className={styles.ctas} />
          <p className={styles.trustLine}>
            No app download <span aria-hidden="true">·</span> No passwords{' '}
            <span aria-hidden="true">·</span> Secure one-time verification
          </p>
        </div>

        <div className={styles.mockupWrap}>
          <img
            src={stockAssets.heroCrowd}
            alt="Fans cheering at a stadium during a live event"
            className={styles.heroPhoto}
            loading="eager"
          />
          <div className={styles.phone} aria-hidden="true">
            <div className={styles.phoneNotch} />
            <div className={styles.phoneScreen}>
              <div className={styles.phoneHeader}>
                <span>Section 112 · Row 8 · Seat 14</span>
              </div>
              <div className={styles.phoneCard}>
                <MockThumb src={mockAssets.vendorStadiumGrill} alt="Stadium Grill vendor logo" />
                <div>
                  <strong>Stadium Grill</strong>
                  <p>12 min · American</p>
                </div>
              </div>
              <div className={styles.phoneCard}>
                <MockThumb src={mockAssets.vendorBayBites} alt="Bay Bites vendor logo" />
                <div>
                  <strong>Bay Bites</strong>
                  <p>8 min · Snacks</p>
                </div>
              </div>
              <div className={styles.phoneOrder}>
                <span>Order #1042</span>
                <strong>Preparing your food</strong>
                <div className={styles.progress}>
                  <span className={styles.progressFill} />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.glow} />
        </div>
      </div>
    </section>
  );
}

export default Hero;
